import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Mail, ChevronDown, Menu, X } from "lucide-react";
import { PLATFORMS } from "../../data/platforms";
import { HUBS } from "../../data/hubs";
import { GUIDES } from "../../data/guides";

const Drop = ({ label, items, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        data-testid={`nav-${testid}-trigger`}
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-3 py-2 text-sm text-white/70 transition-colors hover:text-white"
      >
        {label}
        <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="glass absolute left-0 top-full w-64 rounded-xl p-2" data-testid={`nav-${testid}-menu`}>
          {items.map((it) => (
            <Link
              key={it.href}
              to={it.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-${testid}-${it.id}`}
              className="block rounded-lg px-3 py-2.5 text-sm text-white/70 transition-colors hover:bg-white/5 hover:text-volt"
            >
              {it.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

const Nav = () => {
  const [mobile, setMobile] = useState(false);
  const reviewItems = PLATFORMS.map((p) => ({ id: p.slug, label: `${p.name} Review`, href: `/reviews/${p.slug}` }));
  const hubItems = HUBS.map((h) => ({ id: h.slug, label: h.title.replace("Best Email Marketing ", "For ").replace("Best ", ""), href: `/best/${h.slug}` }));
  const guideItems = [{ id: "all", label: "All Guides", href: "/guides" }, ...GUIDES.map((g) => ({ id: g.slug, label: g.title.split(":")[0], href: `/guides/${g.slug}` }))];

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="glass mx-auto mt-4 flex max-w-6xl items-center justify-between rounded-2xl px-5 py-3 mx-4 lg:mx-auto">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-volt">
            <Mail className="h-4 w-4 text-ink" strokeWidth={2.5} />
          </span>
          <span className="font-display text-base font-extrabold tracking-tight">
            Top Email<span className="text-volt">Tools</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-1 lg:flex" data-testid="nav-desktop">
          <Drop label="Reviews" items={reviewItems} testid="reviews" />
          <Drop label="Best For" items={hubItems} testid="best-for" />
          <Drop label="Guides" items={guideItems} testid="guides" />
          <NavLink to="/resources" data-testid="nav-resources" className="px-3 py-2 text-sm text-white/70 transition-colors hover:text-white">Resources</NavLink>
          <NavLink to="/quiz" data-testid="nav-quiz" className="px-3 py-2 text-sm text-white/70 transition-colors hover:text-white">Quiz</NavLink>
          <Link
            to="/#checklist"
            data-testid="nav-cta-checklist"
            className="ml-3 rounded-full bg-volt px-5 py-2 text-sm font-bold text-ink transition-colors hover:bg-volt-hover"
          >
            Free Checklist
          </Link>
        </nav>
        <button data-testid="nav-mobile-toggle" onClick={() => setMobile(!mobile)} className="lg:hidden" aria-label="Menu">
          {mobile ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {mobile && (
        <div className="glass mx-4 mt-2 max-h-[70vh] overflow-y-auto rounded-2xl p-4 lg:hidden" data-testid="nav-mobile-menu">
          {[{ id: "quiz", label: "Platform Quiz", href: "/quiz" }, { id: "guides", label: "Guides", href: "/guides" }, ...reviewItems, ...hubItems, { id: "resources", label: "Resources", href: "/resources" }, { id: "about", label: "About", href: "/about" }].map((it) => (
            <Link key={it.id} to={it.href} onClick={() => setMobile(false)} data-testid={`nav-mobile-${it.id}`} className="block rounded-lg px-3 py-2.5 text-sm text-white/80 hover:bg-white/5">
              {it.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Nav;
